import { render, staticRenderFns } from "./BackupList.vue?vue&type=template&id=45f2a75e"
import script from "./BackupList.vue?vue&type=script&lang=js"
export * from "./BackupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports